
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-64365a59!../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../node_modules/htmlhint-loader/index.js??ref--0!./404.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/htmlhint-loader/index.js??ref--0!./404.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-64365a59!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/htmlhint-loader/index.js??ref--0!./404.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/404.vue
// module id = 592
// module chunks = 1